import { TagProductType } from '@design-system/components/organisms/tag-product/entities/tag-product.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export enum ProductTags {
  Flexible = 'flexible',
  TravelOutlet = 'travel-outlet',
  Hot = 'hot',
  MemberRate = 'memberrate',
  Rappicard = 'RappiCard',
  Prime = 'Prime',
  Hidden = 'Hidden',
  Marriott = 'Marriott',
  Rappi = 'Rappi',
  Prime_Black = 'Prime_Black',
}

export const TagDsIcon = {
  [ProductTags.Flexible]: Icon.CheckProtection,
  [ProductTags.TravelOutlet]: Icon.Coupon,
  [ProductTags.Hot]: Icon.HotOutline,
};

export const TagDsTypeByClass = {
  [ProductTags.Flexible]: TagProductType.Purple,
  [ProductTags.MemberRate]: TagProductType.Purple,
  [ProductTags.TravelOutlet]: TagProductType.Highlight,
  [ProductTags.Hot]: TagProductType.Highlight,
  [ProductTags.Rappicard]: TagProductType.RappiCard,
  [ProductTags.Prime]: TagProductType.Pro,
  [ProductTags.Marriott]: TagProductType.Marriott,
  [ProductTags.Rappi]: TagProductType.Rappi,
  [ProductTags.Prime_Black]: TagProductType.ProBlack,
};
